import api from "../../../services/axiosConfig";

export const fetchPipelines = async () => {
  try {
    const response = await api.get(
      "/instances/skeye/skeyeingest/list-pipelines",
      {
        data: {},
      },
    );
    return response.data.data.pipelines;
  } catch (error) {
    console.error("Error fetching pipelines:", error);
    throw error;
  }
};

export const createPipeline = async (pipelineData) => {
  try {
    const response = await api.post(
      "/instances/skeye/skeyeingest/create-pipeline",
      pipelineData,
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
    );
    return response.data;
  } catch (error) {
    console.error("Error creating pipeline:", error);
    throw error;
  }
};

export const exportPipeline = async (pipelineId) => {
  try {
    const response = await api.get(
      `/instances/skeye/skeyeingest/export-pipeline/${pipelineId}`,
      {
        data: {},
      },
    );
    return response.data;
  } catch (error) {
    console.error("Error exporting pipeline:", error);
    throw error;
  }
};

export const importPipeline = async (pipelineData) => {
  try {
    const response = await api.post(
      "/instances/skeye/skeyeingest/import-pipeline",
      pipelineData,
      {
        headers: {
          "Content-Type": "application/json",
        },
        timeout: 120000,
      },
    );
    return response.data;
  } catch (error) {
    console.error("Error importing pipeline:", error);
    throw error;
  }
};
